import { useCallback } from "react";

export const useCopyToClipboard = () => {
	const copyToClipboard = useCallback(async (text: unknown): Promise<boolean> => {
		try {
			await navigator.clipboard.writeText(String(text));
			return true;
		} catch (error) {
			console.error("Failed to copy to clipboard:", error);
			return false;
		}
	}, []);

	return { copyToClipboard };
};
